// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Gravatar from 'vue-gravatar';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import { ToastPlugin } from 'bootstrap-vue';
import router from './router';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';

import Copy2Clipboard from '@/shared/copy-2-clipboard/copy-2-clipboard.vue';
import JhiItemCountComponent from '@/shared/jhi-item-count.vue';
import JhiSortIndicatorComponent from '@/shared/sort/jhi-sort-indicator.vue';
import InfiniteLoading from 'vue-infinite-loading';
import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import ConfigurationService from '@/admin/configuration/configuration.service';

import ActivateService from './account/activate/activate.service';
import RegisterService from './account/register/register.service';
import UserManagementService from '@/admin/user-management/user-management.service';
import HeaderSearchService from '@/core/dashboard/dasboard.service';
import UserNotificationService from '@/core/slm-navbar/user-notification.service';

import LoginService from './account/login.service';
import AccountService from './account/account.service';

import vuetify from '@/plugins/vuetify';
import '../content/scss/vendor.scss';
import '../content/scss/main.scss';

import TranslationService from './locale/translation.service';

/* tslint:disable */

import CompanyService from '@/entities/company/company.service';
import ShopService from '@/entities/shop/shop.service';
import UserAccessService from '@/entities/user-access/user-access.service';
import UserCompanyService from '@/entities/user-company/user-company.service';
import UserShopService from '@/entities/user-shop/user-shop.service';
import ProductTypeService from '@/entities/product-type/product-type.service';
import ProductService from '@/entities/product/product.service';
import OrderService from '@/entities/order/order.service';
import OrderItemService from '@/entities/order-item/order-item.service';
import EmailTemplateService from '@/entities/email-template/email-template.service';
import ShopSmtpService from '@/entities/shop-smtp/shop-smtp.service';
import ShopApprovalRuleService from '@/entities/shop-approval-rule/shop-approval-rule.service';
import FileService from '@/entities/file/file.service';

// Widget Services
import ReviewOrdersService from '@/widget/review-orders/review-orders.service';
import LatestOrdersService from '@/widget/latest-orders/latest-orders.service';
import TotalItemsSoldService from '@/widget/total-items-sold/total-items-sold.service';
import ChartDataService from '@/widget/total-items-sold/chart-data.service';

// WYSWYG
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';
import ShopEmailTemplateService from './entities/shop-email-template/shop-email-template.service';

// custom v-select
import VCustomSelect from './shared/select/v-custom-select.vue';

// custom v-menu
import VCustomMenu from './shared/menu/v-custom-menu.vue';

// custom v-text-field type number
import VNumberField from './shared/number-field/v-number-field.vue';

// custom v-text-field
import VCustomTextField from './shared/text-field/v-custom-text-field.vue';

// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);
Vue.use(ToastPlugin);
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi',
});
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);
Vue.component('copy-2-clip', Copy2Clipboard);
Vue.component('v-gravatar', Gravatar);
Vue.component('v-custom-select', VCustomSelect);
Vue.component('v-number-field', VNumberField);
Vue.component('v-custom-menu', VCustomMenu);
Vue.component('v-custom-text-field', VCustomTextField);

const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, router);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        next('/forbidden');
      } else {
        next();
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,
    activateService: () => new ActivateService(),
    registerService: () => new RegisterService(),
    userService: () => new UserManagementService(),

    latestOrdersService: () => new LatestOrdersService(),
    reviewOrdersService: () => new ReviewOrdersService(),
    totalItemsSoldService: () => new TotalItemsSoldService(),
    chartDataService: () => new ChartDataService(),

    healthService: () => new HealthService(),
    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),

    translationService: () => translationService,
    companyService: () => new CompanyService(),
    shopService: () => new ShopService(),
    userAccessService: () => new UserAccessService(),
    userCompanyService: () => new UserCompanyService(),
    userShopService: () => new UserShopService(),
    productTypeService: () => new ProductTypeService(),
    productService: () => new ProductService(),
    orderService: () => new OrderService(),
    orderItemService: () => new OrderItemService(),
    emailTemplateService: () => new EmailTemplateService(),
    shopSmtpService: () => new ShopSmtpService(),
    shopApprovalRuleService: () => new ShopApprovalRuleService(),
    shopEmailTemplateService: () => new ShopEmailTemplateService(),
    fileService: () => new FileService(),
    headerSearchService: () => new HeaderSearchService(),
    userNotificationService: () => new UserNotificationService(),

    accountService: () => accountService,
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
  },
  i18n,
  store,
  vuetify,
});
